export const BULK_CREATE_START = 'BULK_CREATE_START';
export const BULK_CREATE_SUCCESS = 'BULK_CREATE_SUCCESS';
export const BULK_CREATE_ERROR = 'BULK_CREATE_ERROR';
